module.exports = __webpack_public_path__ + "static/media/g-logo.fff5178e.png";